import { Link } from "react-router-dom";
import { ArrowRight, Bike, CalendarCheck, ShoppingBag } from "lucide-react";
import { OWNER_LINE, THREE_WAYS } from "../data/nap";
import { useCart } from "../context/CartContext";

// Home band under the hero: dine-in loudest (what we push), pickup second, delivery = our own courier (no app talk here).
export function ThreeWays() {
  const { deliveryInfo, setChannel } = useCart();
  const deliveryOn = !!deliveryInfo?.available;
  const money = (v) => (v == null ? null : Number(v) % 1 ? Number(v).toFixed(2) : String(Number(v)));
  // Only terms the checkout actually enforces (from /api/delivery/availability); nothing is hard-coded here.
  const terms = deliveryOn ? [
    deliveryInfo.customer_fee != null && `$${money(deliveryInfo.customer_fee)} delivery fee`,
    deliveryInfo.free_delivery_over ? `free on orders $${money(deliveryInfo.free_delivery_over)}+` : null,
    deliveryInfo.club_free_delivery_over ? `Club members free on $${money(deliveryInfo.club_free_delivery_over)}+` : null,
  ].filter(Boolean) : [];
  return (
    <section className="mt-2 mb-10" data-testid="three-ways">
      <div className="grid md:grid-cols-[1.4fr_1fr_1fr] gap-4 items-stretch">
        <Link to="/reservations" data-testid="three-ways-dine-in"
          className="group rounded-3xl bg-[#0F0F0F] text-white p-6 flex flex-col justify-between min-h-[150px] hover:bg-[#1c1c1c] transition-colors">
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#E04F33]">Dine in</p>
          <p className="font-display text-2xl sm:text-3xl font-extrabold mt-2 inline-flex items-center gap-2"><CalendarCheck size={24} aria-hidden="true" /> Book a table <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" aria-hidden="true" /></p>
        </Link>
        <Link to="/store/restaurant" data-testid="three-ways-pickup"
          className="rounded-3xl bg-white border-2 border-neutral-200 hover:border-black p-6 flex flex-col justify-between transition-colors">
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-neutral-500">Pickup</p>
          <p className="font-bold text-base mt-2 inline-flex items-center gap-2"><ShoppingBag size={18} aria-hidden="true" /> Direct from us</p>
          <p className="text-xs text-neutral-500 mt-1">No app fees, the kitchen sees your order first.</p>
        </Link>
        {deliveryOn ? (
          <div className="rounded-3xl bg-[#E04F33] text-white p-6 flex flex-col justify-between" data-testid="three-ways-delivery">
            <p className="text-xs font-bold tracking-[0.2em] uppercase inline-flex items-center gap-2" data-testid="three-ways-delivery-label">
              <span className="relative inline-flex h-2.5 w-2.5" aria-hidden="true">
                <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-300 opacity-75 animate-ping" />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-emerald-400" />
              </span>
              Now delivering
            </p>
            <div className="mt-3">
              <p className="font-display text-2xl sm:text-3xl font-extrabold leading-tight" data-testid="three-ways-delivery-headline">We now deliver.</p>
              <p className="font-bold text-sm sm:text-base mt-1.5 leading-snug">Punjabi Indian food, straight from our kitchen to your door — full menu.</p>
              <p className="text-xs text-white/85 mt-2 leading-relaxed" data-testid="three-ways-delivery-terms">
                {terms.length > 0 && <>{terms.join(" · ")}<br /></>}Enter your address at checkout to see if we deliver to you.
              </p>
            </div>
            <Link to="/store/restaurant" onClick={() => setChannel("delivery")} data-testid="three-ways-delivery-direct"
              className="group mt-4 self-start inline-flex items-center gap-2 bg-white text-[#E04F33] font-bold text-sm px-5 py-2.5 rounded-full hover:bg-[#FDFBF7] transition-colors">
              Order delivery <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" aria-hidden="true" />
            </Link>
          </div>
        ) : (
          <div className="rounded-3xl bg-[#FDFBF7] border border-neutral-200 p-6 flex flex-col justify-between" data-testid="three-ways-delivery">
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-neutral-500">{THREE_WAYS.delivery}</p>
            <p className="font-bold text-base mt-2 inline-flex items-center gap-2"><Bike size={18} aria-hidden="true" /> Coming soon — direct from us</p>
            <p className="text-xs text-neutral-500 mt-1">Pickup is ready now: no app fees, the kitchen sees your order first.</p>
          </div>
        )}
      </div>
      <p className="text-sm sm:text-base text-neutral-700 mt-5 max-w-3xl leading-relaxed" data-testid="owner-line">{OWNER_LINE}</p>
    </section>
  );
}
